import * as chains from "viem/chains";
import { Address, extractChain } from "viem";
import { type ChainId, type ChainIdNum, chainSettings, type ChainType} from "../constants";

const errorText = 'ERR:wrongChain';
const errorUrl = './';

export const explorerUrl = (chainId: ChainType): string => {
  const chainSetting = chainSettings[chainId as ChainIdNum] ? chainSettings[chainId as ChainType] : undefined;

  if (chainSetting?.blockExplorerUrl) {
    return chainSetting.blockExplorerUrl;
  }

  const viemChain = extractChain({chains: Object.values(chains), id: chainId});

  if (viemChain?.blockExplorers?.default?.url) {
    return viemChain.blockExplorers?.default?.url;
  }

  return errorText;
}
export function txLink (txHash: string | Address, chainId: ChainType | number): string {
  const exploreUrl = explorerUrl(chainId as ChainIdNum);

  return exploreUrl !== errorText ? `${exploreUrl}/tx/${txHash}` : errorUrl;
}

export function addressLink (txHash: string | Address, chainId: ChainType | number): string {
  const exploreUrl = explorerUrl(chainId as ChainIdNum);

  return exploreUrl !== errorText ? `${exploreUrl}/address/${txHash}` : errorUrl;
}

export function tokenLink (contractAddress: string | Address, chainId: ChainType | number): string {
  const exploreUrl = explorerUrl(chainId as ChainIdNum);

  return exploreUrl !== errorText ? `${exploreUrl}/token/${contractAddress}` : errorUrl;
}
